import { Button, ButtonSize, ButtonVariant, Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

import Trans from "@/components/Trans/Trans";
import { PresetCardProps } from "@/pages/Chat/components/ModalGenerationSettings/PresetsManager/types";

export function PresetCard({ preset, isUnavailable, getModelName, onApply, onEdit, onDelete, isDisabled }: PresetCardProps) {
  return (
    <div
      className={`flex flex-col gap-1 rounded-md hover:bg-gray-5 dark:hover:bg-gray-7 transition-colors ${
        isUnavailable || isDisabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      } ${isUnavailable ? "border border-red-6 bg-red-2 dark:bg-red-3/20" : ""}`}
      onClick={() => !isDisabled && !isUnavailable && onApply(preset.id)}
    >
      {isUnavailable && (
        <div className="flex flex-row gap-1 items-center">
          <Icon icon={IconVariants.ALERT_TRIANGLE} size={IconSize.SMALL} className="text-red-9" />
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-red-9 text-xs">
            <Trans i18nKey="chat:modal.generationSettings.presets.modelNotAvailable" />
          </Text>
        </div>
      )}
      {/* Line 1: Preset name */}
      <Text variant={TextVariants.LABEL_MEDIUM_MEDIUM} className="text-gray-12 truncate">
        {preset.name}
      </Text>
      {/* Lines 2-3 with icons on the right */}
      <div className="flex flex-row gap-2 items-start">
        {/* Text content on the left */}
        <div className="flex flex-col gap-0.5 flex-1 min-w-0">
          {/* Line 2: Model name + Tokens */}
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className={`text-xs truncate ${isUnavailable ? "text-red-10" : "text-gray-10"}`}>
            {getModelName(preset.modelId)} • <Trans i18nKey="chat:modal.generationSettings.presets.tokens" /> {preset.maxNewTokens}
          </Text>
          {/* Line 3: Other settings */}
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-11 text-xs">
            <Trans i18nKey="chat:modal.generationSettings.presets.temp" /> {preset.temperature.toFixed(2)} •{" "}
            <Trans i18nKey="chat:modal.generationSettings.topP.label" />: {preset.topP.toFixed(2)} •{" "}
            <Trans i18nKey="chat:modal.generationSettings.topK.label" />: {preset.topK}
          </Text>
        </div>
        {/* Icons row on the right */}
        <div className="flex flex-row gap-1 flex-shrink-0" onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}>
          <Button
            onClick={() => onEdit(preset)}
            disabled={isDisabled}
            variant={ButtonVariant.OUTLINED}
            size={ButtonSize.SMALL}
            iconStart={IconVariants.EDIT}
            aria-label="Edit preset"
            className="!p-1 !min-w-0"
          />
          <Button
            onClick={() => onDelete(preset.id)}
            disabled={isDisabled}
            variant={ButtonVariant.OUTLINED}
            size={ButtonSize.SMALL}
            iconStart={IconVariants.TRASH}
            aria-label="Delete preset"
            className="!p-1 !min-w-0"
          />
        </div>
      </div>
    </div>
  );
}
